<template>
    <div
        :class="[
            'schedule-success-container',
            'v2',
            styleTheme,
            isOffer ? 'offer' : ''
        ]"
    >
        <div v-if="isOffer" class="iconfont icon-success_02"></div>
        <p class="success-title">
            {{ title }}
        </p>
        <p class="text">{{ text }}</p>
        <div class="date" v-if="!isOffer">
            <span class="success-date">{{ statusStore.appointTime.date }}</span>
            <span class="success-duration">{{
                statusStore.appointTime.duration
            }}</span>
        </div>
        <div class="btn-wrap">
            <button class="schedule-again" @click="schedulePop(!isOffer)">
                {{ buttonText }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
export default {
    i18next: { ns: 'md-detail-info' },
    inject: ['schedulePop', 'styleTheme'],
    props: {
        isOffer: {
            type: Boolean,
            required: true
        },
        title: {
            type: String
        },
        text: {
            type: String
        },
        buttonText: {
            type: String
        }
    },
    computed: {
        ...mapState({
            statusStore: store => store.scheduleTour
        })
    },
    methods: {}
};
</script>
<style lang="scss">
@import '../../theme/media.scss';
@import '../../theme/mixin.scss';
.schedule-success-container {
    text-align: center;
    .icon-success_02 {
        font-size: 40px;
        color: var(--color-success);
        margin-bottom: 15px;
    }
    .success-title {
        font-size: 20px;
        line-height: 1.2;
        color: var(--g-primary-color);
        font-weight: 700;
        padding-bottom: 10px;
        margin: 0 -15px;
        @include media-800 {
            font-size: 16px;
        }
    }
    .text {
        font-size: 14px;
        color: var(--g-text-color);
        line-height: 1.2;
        margin: 0 -15px;
    }
    .date {
        font-size: 24px;
        line-height: 1.5;
        color: var(--g-btn-background);
        font-weight: 700;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 20px 0;
    }
    .btn-wrap {
        .schedule-again {
            width: 100%;
            height: 40px;
            font-size: 16px;
            font-weight: 700;
            color: var(--g-btn-color);
            background-color: var(--g-btn-background);
            cursor: pointer;
        }
    }
    &.offer {
        .schedule-again {
            background-color: var(--g-bg-color);
            border: 1px solid var(--g-btn-background);
            color: var(--g-btn-background);
            margin-top: 30px;
        }
    }
}
</style>
